var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-lg-flex main-content", attrs: { id: "main-content" } },
      [
        _c(
          "div",
          {
            staticClass: "col-12 p-1 pb-2 px-2 px-lg-3 pb-lg-4",
            attrs: { id: "app" }
          },
          [
            _c(
              "div",
              { staticClass: "row row-cols-1 p-1 m-1 h-100" },
              [
                _c(
                  "transition",
                  { attrs: { name: "slide-up" } },
                  [
                    _c(
                      "keep-alive",
                      [
                        _vm.dynamicComponent == "Home"
                          ? _c("Mood", {
                              style: { opacity: _vm.logoOpacity },
                              attrs: { user: _vm.user }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    attrs: {
                      name:
                        _vm.dynamicComponent !== "Home" &&
                        this.$nav_history[this.$nav_history.length - 2] !==
                          "Home"
                          ? "slide-up"
                          : ""
                    }
                  },
                  [
                    _c(_vm.dynamicComponent, {
                      key: _vm.dynamicComponent,
                      tag: "component",
                      attrs: {
                        mood: _vm.mood,
                        user: _vm.user,
                        parent: _vm.$options.name
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fae5bece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fae5bece","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 